<template>
    <div class="content-main col-md-12 col-sm-12 col-xs-12">
        <div class="row">
            <div class="page-title div-img-header" :style="[ShopIntroductionsInfo.PicPath != null ? {background:`url(${ShopIntroductionsInfo.PicPath}) center center /cover no-repeat local`} : '']">
                    <div class="container">
                        <div class="row">
                            <div class="div-title-main col col-xs-12">
                                <h2>لیست قیمت لپ تاپ</h2>
                                <ol class="breadcrumb">
                                    <li><a href="/" title="صفحه اصلی">صفحه اصلی</a></li>
                                    <li>لیست قیمت لپ تاپ</li>
                                </ol>
                            </div>
                        </div> <!-- end row -->
                    </div>
            </div>
            <div class="content">
                <div class="div-content pb-20">
                    <div class="row">
                        <div class="section-about col-xs-12 col-lg-12 col-md-12">
                            <h1> لیست قیمت لپ تاپ </h1>
                            <div v-html="ShopIntroductionsInfo.Context"></div>
                        </div>
                        <!--<div class="pt-60 col-lg-7 col-lg-7 d-none d-md-block d-md-none">
                    <div class="offer-pic">
                        <img src="/assets/img/inline-page/offer-pic.jpg" alt="دومان دیزل" title="دومان دیزل"/>
                    </div>
                </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                ShopIntroductionsInfo: {}
            }
        },
        beforeMount: function () {
            this.scrollTop();
            createPageTitle('لیست قیمت لپ تاپ');
            httpPromise(this, '/v1/BasicDefinitions/ShopIntroductions/Find', 'get', { SectionNameEN: "LaptopPriceList" },
                response => {
                    this.ShopIntroductionsInfo = response.data.Value;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                });
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            scrollTop() {
                $(function () {
                    $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo');
                });
            }
        },
        components: {

        }
    }
</script>


<style scoped>

    .pt-60 {
        padding-top: 60px;
    }

    .div-title-main {
        padding-right: 150px;
    }

    .div-img-header {
        background: url("/assets/img/header/page-title.jpg") center center/cover no-repeat local;
        height: 260px;
        position: relative;
        width: 100%;
    }

    div-img-header
    .page-title .breadcrumb {
        text-align: center;
    }

    .page-title .breadcrumb {
        background-color: transparent;
        padding: 0;
    }

    .page-title ol {
        color: #fff;
    }

    .page-title h2 {
        font-size: 48px;
        font-size: 3.2rem;
        font-weight: 800;
        margin: 1em 0 0.23em;
    }

    .page-title h2 {
        color: #fff;
    }

    .page-title .breadcrumb li a {
        color: #fff;
    }

    .page-title .breadcrumb li {
        font-size: 18px;
        font-size: 1.2rem;
        color: #fdc900;
        margin-left: 5px;
    }

    .page-title::before {
        content: "";
        background-color: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .page-title .breadcrumb > li + li::before {
        font-family: "FontAwesome";
        content: "\f104";
        color: #fff;
        margin-left: 5px;
    }


    .section-about h1 {
        font-size: 30px;
    }

    .page-title .breadcrumb li a:hover {
        color: #fdc900;
    }

    .pb-20 {
        padding-bottom: 100px;
    }

    .mt-15 {
        margin-top: 15px;
    }

    .hr {
        margin-top: 45px;
        margin-bottom: 30px;
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/

    .content-main .content {
        width: 100%;
        margin: 20px 12%;
        padding: 20px;
    }

        .content-main .content .title {
            font-size: 20px;
            padding-right: 20px;
            padding-top: 20px;
        }

        .content-main .content .div-content p {
            line-height: 2;
            font-size: 15px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .pb-20 {
            padding-bottom: 10px;
        }

        .section-about h1 {
            font-size: 19px;
        }

        .div-title-main {
            padding-right: 20px;
        }

        .content-main .content {
            margin: 40px 0%;
        }

            .content-main .content .title {
                font-size: 17px;
            }

            .content-main .content .div-content p {
                line-height: 2;
                font-size: 12px;
            }
    }
    /*محتویات Css  قسمت مدیریت صفحات استاتیک*/
</style>